var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"inputRef",staticClass:"mt-1 select-input",attrs:{"solo":"","hide-details":"","placeholder":"0.00","disabled":_vm.disabled}})}
var staticRenderFns = []
export { render, staticRenderFns }